var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.internalValue == 1)?_c('span',{staticClass:"label published"},[_vm._v("Yes")]):_vm._e(),_vm._v(" "),(_vm.internalValue == 0)?_c('span',{staticClass:"label unpublished"},[_vm._v("No")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-017b1312","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Active.vue
// module id = 861
// module chunks = 0